const basePath = "/simulador-fondo-vida-garantizado";
const zonaNombre = "Simulador Fondo Vida Garantizado";

const defaultValues = {
  event: "virtualPage",
  partner: "Pacífico",
  partnerType: "Pacífico",
};

export const gtmOnloadPage = (pagePath, pageTitle) => {
  if (!pagePath || !pageTitle) {
    console.warn("gtmOnloadPage: faltan parámetros obligatorios");
    return;
  }

  if (typeof window.dataLayer === 'undefined') {
    console.warn("gtmOnclick: 'dataLayer' no está definido en el contexto global.");
    return;
  }

  window.dataLayer.push({
    ...defaultValues,
    pagePath: `${basePath}/${pagePath}`,
    pageName: `${zonaNombre} - ${pageTitle}`,
  });

  localStorage.setItem("gtmPageTitle", pageTitle);
};
